import publicationApi from '@/apis/publications'

const getPublicationsByAfId = async ({ commit }, { id, subs }) => {
  try {
    const {
      data: publications
    } = await publicationApi.getPublicationsByCustomerSubs(id, subs)

    commit('PUBLICATION_UPDATE', publications.payload.publications)
  } catch (error) {
    console.error('Failed to get publications by affId with customer subs due to %s', error)
  }
}

export default {
  getPublicationsByAfId
}
